import { get } from "lodash-es"
import React, { createContext, useContext } from "react"

const FormContext = createContext()
const ContextForm = ({
  id,
  className,
  source,
  loading,
  errors,
  children,
  onChange,
  onAdd,
  focused,
  onSubmit,
  onFocus,
  disable,
  onRemove,
  isSubmitted,
}) => {
  function handleSubmit(e) {
    e.preventDefault()
    onSubmit(source, errors)
  }
  return (
    <FormContext.Provider
      value={{
        source,
        loading,
        errors,
        focused,
        onFocus,
        onChange,
        onAdd,
        onRemove,
        disable,
        isSubmitted,
      }}
    >
      <form id={id} className={className} action="#" onSubmit={handleSubmit}>
        {children}
      </form>
    </FormContext.Provider>
  )
}

const useContextForm = path => {
  const {
    source,
    errors,
    focused,
    onChange,
    onFocus,
    onAdd,
    onRemove,
    disable,
    isSubmitted,
  } = useContext(FormContext)
  const value = get(source, path)
  const error = get(errors, `details.${path}`, null)
  const touched = isSubmitted ? true : get(focused, path, false)
  const disabled = disable === "all" ? true : get(disable, path, null)

  return {
    value,
    error,
    touched,
    disabled,
    onChange,
    onAdd,
    onFocus,
    onRemove,
  }
}

export default ContextForm
export { useContextForm }
